<template>
    <div class="phone">
      <vs-tooltip :text="this.country_name" color="primary">
        <country-flag :country="this.country_code" size="normal" class="phone-img" />
      </vs-tooltip>
      <span class="phone-number">{{ this.phone }}</span>
    </div>
  </template>
  
  <script>
  import CountryFlag from 'vue-country-flag'
  
  export default {
    name: "ChildPhoneImageCell",
    props: {
      phone: String,
      country_code: String,
      country_name: String
    },
    components: {
      CountryFlag
    },
    data () {
      return {
      }
    },
  };
  </script>
  <style>
  .phone {
    display: flex;
    align-items: center;
  }
  .phone-img {
    border-radius: 50%;
    align-items: center;
    margin-bottom: unset !important;
  }
  
  .phone-number {
    margin-left: 8px !important;
    color: #5e5873 !important;
  }
  </style>
  